import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('choose_file'),
    uploadButtonTitle: defineMessage('upload'),
    uploadAsAttachmentsText: defineMessage('i_want_to_upload_these_files_as_attachments'),
    ocrUploadText: defineMessage('choose_the_only_one_fil_the_approvalmax_capture'),
    ocrUnsupportedFormatText: defineMessage('files_that_we_do_not_support'),
    attachemntsUploadText: defineMessage('choose_the_files'),
};
